import FuelSamplesController from "./fuel_samples_controller"
// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AirportSearchController from "./airport_search_controller"
import AutoMomentController from "./auto_moment_controller"
import AutoSubmitController from "./auto_submit_controller"
import BulkSelectController from "./bulk_select_controller"
import FormSubmitController from "./form_submit_controller"
import ToastController from "./toast_controller"
import GearModalController from "./gear_modal_controller"
import GearPopoverController from "./gear_popover_controller"
import NestedFormController from "./nested_form_controller"
import NestedRemoveController from "./nested_remove_controller"
import SingleScaleModalController from "./single_scale_modal_controller"
import WeightChartController from "./weight_chart_controller"
import AircraftConfigSelectController from "./aircraft_config_select_controller"
import AircraftResearchController from "./aircraft_research_controller"
import AircraftSelectController from "./aircraft_select_controller"
import WsEditorController from "./ws_editor_controller"
import ClipboardController from "./clipboard_controller"
import CorrectionPointController from "./correction_point_controller"
import ReadingAdjustmentController from "./reading_adjustment_controller"
import ReadingCaptureController from "./reading_capture_controller"
import PitchCaptureController from "./pitch_capture_controller"
import ToggleFieldsController from "./toggle_fields_controller"
import OfflineController from "./offline_controller"
import SignOutController from "./sign_out_controller"
import MissingFieldsController from "./missing_fields_controller"
import DeferredFrameController from "./deferred_frame_controller"
application.register("offline", OfflineController)
application.register("sign-out", SignOutController)
application.register("missing-fields", MissingFieldsController)
application.register("deferred-frame", DeferredFrameController)
application.register("toggle-fields", ToggleFieldsController)
application.register("correction-point", CorrectionPointController)
application.register("reading-adjustment", ReadingAdjustmentController)
application.register("reading-capture", ReadingCaptureController)
application.register("pitch-capture", PitchCaptureController)
application.register("clipboard", ClipboardController)
application.register("aircraft-config-select", AircraftConfigSelectController)
application.register("aircraft-research", AircraftResearchController)
application.register("aircraft-select", AircraftSelectController)
application.register("ws-editor", WsEditorController)
application.register("weight-chart", WeightChartController)
application.register("airport-search", AirportSearchController)
application.register("auto-moment", AutoMomentController)
application.register("auto-submit", AutoSubmitController)
application.register("bulk-select", BulkSelectController)
application.register("form-submit", FormSubmitController)
application.register("gear-modal", GearModalController)
application.register("gear-popover", GearPopoverController)
application.register("nested-form", NestedFormController)
application.register("nested-remove", NestedRemoveController)
application.register("single-scale-modal", SingleScaleModalController)
application.register("toast", ToastController)

application.register("fuel-samples", FuelSamplesController)
